import React, { Component } from "react";
import {
    Input,
    Segment,
    Form,
    Checkbox,
    TextArea,
    Button,
} from "semantic-ui-react";
import { connect } from "react-redux";
import DatePicker from "../DatePicker";
import { format, isBefore, parse } from "date-fns";
import EntityAvailability from "./EntityAvailability";
import MembershipTypeSearchSelect from "../../../assets/components/MembershipTypeSearchSelect";

const DATE_ONLY_FORMAT = "yyyy-MM-dd";

const formatDateOnly = (date) => format(date, DATE_ONLY_FORMAT);

const parseDateOnly = (date) => {
    if (date instanceof Date) return date;
    if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
        return parse(date, DATE_ONLY_FORMAT, new Date());
    }
    return new Date(date);
};

class Availability extends Component {
    constructor(props) {
        super(props);

        this.daysOfWeek = [
            {
                key: 0,
                value: "monday",
                text: "Monday",
            },
            {
                key: 1,
                value: "tuesday",
                text: "Tuesday",
            },
            {
                key: 2,
                value: "wednesday",
                text: "Wednesday",
            },
            {
                key: 3,
                value: "thursday",
                text: "Thursday",
            },
            {
                key: 4,
                value: "friday",
                text: "Friday",
            },
            {
                key: 5,
                value: "saturday",
                text: "Saturday",
            },
            {
                key: 6,
                value: "sunday",
                text: "Sunday",
            },
        ];

        this.seasons = [
            {
                key: 0,
                value: "winter",
                text: "Winter",
            },
            {
                key: 1,
                value: "summer",
                text: "Summer",
            },
        ];

        this.times = [
            {
                key: 0,
                value: "am",
                text: "AM",
            },
            {
                key: 1,
                value: "pm",
                text: "PM",
            },
        ];

        this.state = {
            bookingPlayersDraft: {
                cashMin: String(this.props.club.bookingCashMinPlayers ?? 1),
                cashMax: String(this.props.club.bookingCashMaxPlayers ?? 100),
                creditMin: String(this.props.club.bookingCreditMinPlayers ?? 4),
                creditMax: String(this.props.club.bookingCreditMaxPlayers ?? 4),
            },
            bookingPlayersWarnings: {
                cashMin: null,
                cashMax: null,
                creditMin: null,
                creditMax: null,
            },
        };
    }

    errorsFor(field) {
        if (this.props.validation !== null) {
            if (typeof this.props.validation[field] !== "undefined") {
                return (
                    <>
                        <span className='has-error'>
                            {" "}
                            {this.props.validation[field][0]}{" "}
                        </span>
                        <br />
                    </>
                );
            }
        }
    }

    onChangeEntityShowHide(show, hide) {
        const { club } = this.props;
        club.entitiesShow = show;
        club.entitiesHide = hide;
        this.props.update(club);
    }

    onChangeShowForRoles(value) {
        const { club } = this.props;
        club.showForRoles = value;
        this.props.update(club);
    }

    addUnavailablePeriod() {
        const { club } = this.props;
        club.unavailable.push({
            from: formatDateOnly(new Date()),
            to: formatDateOnly(new Date()),
        });
        this.props.update(club);
    }

    onChangeUnavailableFrom(index, value) {
        const { club } = this.props;
        const period = club.unavailable[index];
        period.from = formatDateOnly(value);
        if (period.to !== null && isBefore(parseDateOnly(period.to), value)) {
            period.to = period.from;
        }
        this.props.update(club);
    }

    onChangeUnavailableTo(index, value) {
        const { club } = this.props;
        club.unavailable[index].to = formatDateOnly(value);
        this.props.update(club);
    }

    onChangeUnavailableToNoExpiry(index) {
        const { club } = this.props;
        if (club.unavailable[index].to === null) {
            club.unavailable[index].to =
                club.unavailable[index].from || formatDateOnly(new Date());
        } else {
            club.unavailable[index].to = null;
        }

        this.props.update(club);
    }

    onChangeUnavailableDescription(index, value) {
        const { club } = this.props;
        club.unavailable[index].description = value;
        this.props.update(club);
    }

    removeUnavailablePeriod(index) {
        const { club } = this.props;
        club.unavailable.splice(index, 1);
        this.props.update(club);
    }

    gatherInputInt(property, value) {
        const { club } = this.props;
        club[property] = parseInt(value, 10) || 0;
        this.props.update(club);
    }

    gatherInputIntClamped(property, value, min, max) {
        const { club } = this.props;
        let n = parseInt(value, 10);

        if (Number.isNaN(n)) n = min;
        if (n < min) n = min;
        if (n > max) n = max;

        club[property] = n;
        this.props.update(club);
    }
    setBookingDraft(key, value) {
        const next = value === "" ? "" : value.replace(/[^\d]/g, "");
        this.setState((s) => ({
            bookingPlayersDraft: { ...s.bookingPlayersDraft, [key]: next },
            bookingPlayersWarnings: {
                ...s.bookingPlayersWarnings,
                [key]: null,
            },
        }));
    }
    setBookingWarning(key, msg) {
        this.setState((s) => ({
            bookingPlayersWarnings: { ...s.bookingPlayersWarnings, [key]: msg },
        }));
    }
    commitBookingPlayerRange(kind, field) {
        const { club } = this.props;

        const bounds =
            kind === "cash" ? { min: 1, max: 100 } : { min: 2, max: 4 };
        const minKey =
            kind === "cash"
                ? "bookingCashMinPlayers"
                : "bookingCreditMinPlayers";
        const maxKey =
            kind === "cash"
                ? "bookingCashMaxPlayers"
                : "bookingCreditMaxPlayers";
        const draftMinKey = kind === "cash" ? "cashMin" : "creditMin";
        const draftMaxKey = kind === "cash" ? "cashMax" : "creditMax";

        const clamp = (n) => Math.min(bounds.max, Math.max(bounds.min, n));

        const rawMin = this.state.bookingPlayersDraft[draftMinKey];
        const rawMax = this.state.bookingPlayersDraft[draftMaxKey];

        const originalDraftMin = rawMin;
        const originalDraftMax = rawMax;

        let min = clamp(parseInt(rawMin, 10));
        let max = clamp(parseInt(rawMax, 10));

        if (Number.isFinite(min) === false) min = club[minKey] ?? bounds.min;
        if (Number.isFinite(max) === false) max = club[maxKey] ?? bounds.max;

        let warningKey = null;
        let warningMsg = null;

        // Relationship enforcement: snap ONLY the edited field back
        if (min > max) {
            if (field === "min") {
                warningKey = draftMinKey;
                warningMsg = `Minimum cannot be more than maximum — adjusted to ${max}. Please check.`;
                min = max;
            } else {
                warningKey = draftMaxKey;
                warningMsg = `Maximum cannot be less than minimum — adjusted to ${min}. Please check.`;
                max = min;
            }
        }

        // Bounds warning if clamped
        if (field === "min") {
            const clamped = String(clamp(parseInt(originalDraftMin, 10)));
            if (originalDraftMin !== "" && clamped !== originalDraftMin) {
                warningKey = draftMinKey;
                warningMsg = `Value must be between ${bounds.min} and ${bounds.max} — adjusted to ${clamped}. Please check.`;
            }
        } else {
            const clamped = String(clamp(parseInt(originalDraftMax, 10)));
            if (originalDraftMax !== "" && clamped !== originalDraftMax) {
                warningKey = draftMaxKey;
                warningMsg = `Value must be between ${bounds.min} and ${bounds.max} — adjusted to ${clamped}. Please check.`;
            }
        }

        club[minKey] = min;
        club[maxKey] = max;
        this.props.update(club);

        this.setState((s) => ({
            bookingPlayersDraft: {
                ...s.bookingPlayersDraft,
                [draftMinKey]: String(min),
                [draftMaxKey]: String(max),
            },
            bookingPlayersWarnings: {
                ...s.bookingPlayersWarnings,
                ...(warningKey ? { [warningKey]: warningMsg } : {}),
            },
        }));
    }
    onChangeBookingPlayerRange(kind, field, rawValue) {
        const { club } = this.props;

        const minKey =
            kind === "cash"
                ? "bookingCashMinPlayers"
                : "bookingCreditMinPlayers";
        const maxKey =
            kind === "cash"
                ? "bookingCashMaxPlayers"
                : "bookingCreditMaxPlayers";

        const bounds =
            kind === "cash" ? { min: 1, max: 100 } : { min: 2, max: 4 };

        const clamp = (n) => Math.min(bounds.max, Math.max(bounds.min, n));
        const n = parseInt(rawValue, 10);

        if (Number.isNaN(n)) return;

        const currentMin = parseInt(club[minKey] ?? bounds.min, 10);
        const currentMax = parseInt(club[maxKey] ?? bounds.max, 10);

        let nextMin = currentMin;
        let nextMax = currentMax;

        if (field === "min") {
            nextMin = clamp(n);

            // ✅ if min would exceed max, snap min back to max (do NOT bump max)
            if (nextMin > nextMax) nextMin = nextMax;
        } else {
            nextMax = clamp(n);

            // ✅ if max would be below min, snap max back to min (do NOT bump min)
            if (nextMax < nextMin) nextMax = nextMin;
        }

        club[minKey] = nextMin;
        club[maxKey] = nextMax;
        this.props.update(club);
    }

    onChangeBookingTerms(value) {
        const { club } = this.props;
        club.bookingTerms = value;
        this.props.update(club);
    }

    noExpiryOverlay = ({ classNames, selectedDay, children, ...props }) => {
        const index = props.input.props.name;
        const period = this.props.club.unavailable[index];
        return (
            <div className='pb-3' {...props}>
                <div className={classNames.overlay}>
                    {children}
                    <div className='text-center'>
                        <Checkbox
                            toggle
                            name='primary'
                            label='No expiry'
                            value={index}
                            checked={period.to === null}
                            onChange={() =>
                                this.onChangeUnavailableToNoExpiry(index)
                            }
                        />
                    </div>
                </div>
            </div>
        );
    };

    unavailablePeriods() {
        return this.props.club.unavailable.map((period, index) => {
            return (
                <Segment vertical key={index}>
                    <div className='row'>
                        <div className='col-12 col-lg-3'>
                            <label className='with-input'>
                                Unavailable from
                            </label>
                            <DatePicker
                                value={parseDateOnly(period.from)}
                                onDayChange={(value) => {
                                    this.onChangeUnavailableFrom(index, value);
                                }}
                                dayPickerProps={{
                                    disabledDays: (day) =>
                                        isBefore(day, new Date()),
                                }}
                            />
                        </div>
                        <div className='col-12 col-lg-3'>
                            <label className='with-input'>Unavailable to</label>
                            <DatePicker
                                value={parseDateOnly(period.to)}
                                onDayChange={(value) => {
                                    this.onChangeUnavailableTo(index, value);
                                }}
                                dayPickerProps={{
                                    disabledDays: (day) =>
                                        isBefore(day, parseDateOnly(period.to)),
                                }}
                            />
                        </div>

                        <div className='col-9 col-lg-3'>
                            <label className='with-input'>Description</label>
                            <Input
                                fluid
                                name={index}
                                placeholder='Why is this club unavailable?'
                                value={period.description || ""}
                                onChange={({ target }) =>
                                    this.onChangeUnavailableDescription(
                                        index,
                                        target.value,
                                    )
                                }
                            />
                        </div>
                        <div className='col-3 col-lg-3 d-flex align-items-end justify-content-end'>
                            <Button
                                primary
                                className='red mt-3'
                                value={index}
                                onClick={() =>
                                    this.removeUnavailablePeriod(index)
                                }
                            >
                                Remove
                            </Button>
                        </div>
                    </div>
                </Segment>
            );
        });
    }

    render() {
        return (
            <>
                <Segment vertical>
                    <h4>Club unavailable</h4>
                    <p>
                        Define a start and end date for when this club wil be
                        unavailable
                    </p>
                    {this.unavailablePeriods()}
                    <Segment vertical>
                        <Button
                            primary
                            className='theme'
                            onClick={this.addUnavailablePeriod.bind(this)}
                        >
                            Add unavailable period
                        </Button>
                    </Segment>
                </Segment>
                <Segment vertical>
                    <h4>Club visibility</h4>
                    <p>
                        Define which membership types are able to see this club
                        within the MASHIE app. Leave blank to hide this club
                        entirely.
                    </p>
                    <MembershipTypeSearchSelect
                        fluid
                        value={this.props.club.showForRoles}
                        placeholder='Select which memberships can view this club'
                        onChange={(value) => this.onChangeShowForRoles(value)}
                    />
                </Segment>
                <Segment vertical>
                    <EntityAvailability
                        club={this.props.club}
                        onChange={this.onChangeEntityShowHide.bind(this)}
                    />
                </Segment>
                <Segment vertical>
                    <h4>Booking lead time</h4>
                    <p>
                        How many days should be blocked out before a customer
                        can book?
                    </p>
                    {this.errorsFor("bookingLeadTime")}
                    <Input
                        className='mt-3'
                        fluid
                        name='bookingLeadTime'
                        value={this.props.club.bookingLeadTime ?? ""}
                        onChange={({ target }) =>
                            this.gatherInputInt("bookingLeadTime", target.value)
                        }
                    />
                </Segment>
                <Segment vertical>
                    <h4>Booking max time</h4>
                    <p>
                        How many days in the future should a customer be able to
                        book?
                    </p>
                    {this.errorsFor("bookingMaxTime")}
                    <Input
                        className='mt-3'
                        fluid
                        name='bookingMaxTime'
                        value={this.props.club.bookingMaxTime ?? ""}
                        onChange={({ target }) =>
                            this.gatherInputInt("bookingMaxTime", target.value)
                        }
                    />
                </Segment>
                <Segment vertical>
                    <h4>Booking Terms</h4>
                    <p>
                        If there are any terms that players need to be aware of
                        when making a booking, please add them here.
                    </p>
                    {this.errorsFor("bookingTerms")}
                    <Form>
                        <TextArea
                            className='mt-3'
                            name='bookingTerms'
                            placeholder='Booking terms'
                            value={this.props.club.bookingTerms ?? ""}
                            onChange={(_, { value }) =>
                                this.onChangeBookingTerms(value)
                            }
                        />
                    </Form>
                </Segment>
                <Segment vertical>
                    <h4>Green Fee Booking Players</h4>
                    <p>
                        Set the minimum and maximum number of players allowed
                        for Green Fee (cash) bookings.
                    </p>

                    <div className='row'>
                        <div className='col-12 col-lg-6'>
                            <label className='with-input'>
                                Minimum players
                            </label>
                            <Input
                                fluid
                                inputMode='numeric'
                                pattern='[0-9]*'
                                value={this.state.bookingPlayersDraft.cashMin}
                                onChange={({ target }) =>
                                    this.setBookingDraft(
                                        "cashMin",
                                        target.value,
                                    )
                                }
                                onBlur={() =>
                                    this.commitBookingPlayerRange("cash", "min")
                                }
                            />
                            {this.state.bookingPlayersWarnings.cashMin && (
                                <div
                                    className='has-error'
                                    style={{ marginTop: 6 }}
                                >
                                    {this.state.bookingPlayersWarnings.cashMin}
                                </div>
                            )}
                        </div>

                        <div className='col-12 col-lg-6'>
                            <label className='with-input'>
                                Maximum players
                            </label>
                            <Input
                                fluid
                                inputMode='numeric'
                                pattern='[0-9]*'
                                value={this.state.bookingPlayersDraft.cashMax}
                                onChange={({ target }) =>
                                    this.setBookingDraft(
                                        "cashMax",
                                        target.value,
                                    )
                                }
                                onBlur={() =>
                                    this.commitBookingPlayerRange("cash", "max")
                                }
                            />
                            {this.state.bookingPlayersWarnings.cashMax && (
                                <div
                                    className='has-error'
                                    style={{ marginTop: 6 }}
                                >
                                    {this.state.bookingPlayersWarnings.cashMax}
                                </div>
                            )}
                        </div>
                    </div>
                </Segment>

                <Segment vertical>
                    <h4>Green Fee Credit Booking Players</h4>
                    <p>
                        Set the minimum and maximum number of players allowed
                        for Green Fee Credit bookings.
                    </p>

                    <div className='row'>
                        <div className='col-12 col-lg-6'>
                            <label className='with-input'>
                                Minimum players
                            </label>
                            <Input
                                fluid
                                inputMode='numeric'
                                pattern='[0-9]*'
                                value={this.state.bookingPlayersDraft.creditMin}
                                onChange={({ target }) =>
                                    this.setBookingDraft(
                                        "creditMin",
                                        target.value,
                                    )
                                }
                                onBlur={() =>
                                    this.commitBookingPlayerRange(
                                        "credit",
                                        "min",
                                    )
                                }
                            />
                            {this.state.bookingPlayersWarnings.creditMin && (
                                <div
                                    className='has-error'
                                    style={{ marginTop: 6 }}
                                >
                                    {
                                        this.state.bookingPlayersWarnings
                                            .creditMin
                                    }
                                </div>
                            )}
                        </div>

                        <div className='col-12 col-lg-6'>
                            <label className='with-input'>
                                Maximum players
                            </label>
                            <Input
                                fluid
                                inputMode='numeric'
                                pattern='[0-9]*'
                                value={this.state.bookingPlayersDraft.creditMax}
                                onChange={({ target }) =>
                                    this.setBookingDraft(
                                        "creditMax",
                                        target.value,
                                    )
                                }
                                onBlur={() =>
                                    this.commitBookingPlayerRange(
                                        "credit",
                                        "max",
                                    )
                                }
                            />
                            {this.state.bookingPlayersWarnings.creditMax && (
                                <div
                                    className='has-error'
                                    style={{ marginTop: 6 }}
                                >
                                    {
                                        this.state.bookingPlayersWarnings
                                            .creditMax
                                    }
                                </div>
                            )}
                        </div>
                    </div>
                </Segment>
                <div className='row'>
                    <div className='col'>
                        <Segment vertical>
                            <Button
                                size='large'
                                floated='right'
                                className='theme'
                                primary
                                onClick={this.props.save}
                            >
                                Save
                            </Button>
                        </Segment>
                    </div>
                </div>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        notification: state.notification,
        validation: state.validation,
    };
}

export default connect(mapStateToProps)(Availability);
